#import "../../common/graphql/EntityDocumentsFields.graphql"

query AttachablePayCycleDocuments(
  $first: Int
  $after: Cursor
  $payCycleId: UUID
  $paymentAccountId: UUID
  $documentTypeId: Int
  $orderBy: [EntityDocumentsOrderBy!]
  $filter: EntityDocumentFilter
) {
  attachablePayCycleDocuments(
    first: $first
    after: $after
    payCycleId: $payCycleId
    documentTypeId: $documentTypeId
    orderBy: $orderBy
    filter: $filter
    paymentAccountId: $paymentAccountId
  ) {
    nodes {
      ...EntityDocumentsFields
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      endCursor
    }
  }
}
